import { createFileRoute } from '@tanstack/react-router';
import { PaymentModule } from '@/modules/payment';

export const Route = createFileRoute('/(dashboard)/_dashboard/loan/$id')({
  component: PaymentModule,
});
